// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { observable, action } from 'mobx'
import { getFromApi } from '../services/apiService'
import { IDescription } from './bookingTypes'
import { IStores } from '.'
import { sendDescriptionEvent } from '../services/analyticsService'
import { MediaBreakpointType } from '../hooks/useMediaBreakpoint'

const buildDESCRIPTION_URL = (reference: string) => `/v2/common/descriptions/${reference}`

class DescriptionStore {
  store: IStores

  @observable loading = false;
  @observable descriptions: Map<string, IDescription> = new Map();

  constructor(store: IStores) {
    this.store = store
  }

  @action get = async (reference: string): Promise<IDescription | null> => {
    sendDescriptionEvent('click_info', reference)

    let description = this.descriptions.get(reference)

    if (description) {
      return description
    }
    this.loading = true

    const response = await getFromApi(buildDESCRIPTION_URL(reference))

    if (response && response.status === 200) {
      description = response.data.description

      if (description) {
        this.descriptions.set(reference, description)
      }
    }

    this.loading = false

    return description || null
  }



  /**
   * @returns {Array<String>}
   * @descriptions Get marketing list of references for the popup carousel
   */
  @action
  getMarketingReferences = async (mediaBreakpoint: MediaBreakpointType): Promise<Array<string> | null> => {
    const response = await getFromApi('v5/marketing/banners', { mediaBreakpoint }, true)

    if (response.data) {
      return response.data
    }

    return null
  }
}

export default DescriptionStore
